import { Directive, Input, ElementRef, OnChanges } from '@angular/core';
import { CommonBindingDataService } from '../services/common-binding-data.service';

@Directive({
  selector: '[appLogicalAccessProvider]'
})
export class LogicalAccessProviderDirective implements OnChanges {
  @Input() accessCode;
  @Input() accessGroupCode;
  private _el: HTMLElement;
  private menuAccessList: any[];

  constructor(el: ElementRef, private commonBindingDataService: CommonBindingDataService) {
    this._el = el.nativeElement;
  }

  ngOnChanges() {
    this.menuAccessList = this.commonBindingDataService.checkLogicalGroupAccess(this.accessGroupCode);
    const hasAccess = this.menuAccessList.find((elm) => {
      return elm.accessCode === this.accessCode;
    });
    if (!hasAccess) {
      this._el.style.display = 'none';
    }
  }

}
